export default __webpack_public_path__ + "static/media/Departments.cdfe521d.svg";